import { render, staticRenderFns } from "./CustomerMatchDetail.vue?vue&type=template&id=ed59b97c"
import script from "./CustomerMatchDetail.vue?vue&type=script&lang=ts"
export * from "./CustomerMatchDetail.vue?vue&type=script&lang=ts"
import style0 from "./CustomerMatchDetail.vue?vue&type=style&index=0&id=ed59b97c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports